module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mapSeek"
  }, [_c('el-select', {
    staticClass: "inpLoc",
    attrs: {
      "filterable": "",
      "remote": "",
      "reserve-keyword": "",
      "placeholder": "输入所在地点",
      "remote-method": _vm.locSeek,
      "loading": _vm.loading
    },
    on: {
      "change": _vm.locSelect
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }, _vm._l((_vm.locationArr), function(item) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "color": "#999999",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(item.district))])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-6f5fd59a"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/inCComps/mapSeek.vue
// module id = 1519
// module chunks = 1